import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { Master_Service_URL, CommonListing_URL } from "../Url";

export const functionMasterListActions = {
  FUNCTION_MASTER_LIST_SUCCESS: "FUNCTION_MASTER_LIST_SUCCESS",
  FUNCTION_MASTER_LIST_ERROR: "FUNCTION_MASTER_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export const partnerMasterListActions = {
  PARTNER_MASTER_SUCCESS: "PARTNER_MASTER_SUCCESS",
  PARTNER_MASTER_ERROR: "PARTNER_MASTER_ERROR",
  LOGOUT: "LOGOUT",
};

export const productListActions = {
  PRODUCT_LIST_SUCCESS: "PRODUCT_LIST_SUCCESS",
  PRODUCT_LIST_ERROR: "PRODUCT_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export const allMasterListActions = {
  ALL_MASTER_LIST_SUCCESS: "ALL_MASTER_LIST_SUCCESS",
  ALL_MASTER_LIST_ERROR: "ALL_MASTER_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getAllType(props) {
  const { access_token, url, type } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/get/partnerEngagementDetailsMasters`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAllMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getAllMasterListError(err));
          return err.response;
        }
      });
}

//Bank Master functions

export function getAllMasterListSuccess() {
  return {
    type: allMasterListActions.ALL_MASTER_LIST_SUCCESS,
    isPosting: true,
  };
}
export function getAllMasterListError(error) {
  return {
    type: allMasterListActions.ALL_MASTER_LIST_ERROR,
    payload: error,
  };
}

export function getFunction(props) {
  const { access_token, url, type } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_URL}/getAllFunctionTypeMaster`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getFunctionMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getFunctionMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getFunctionMasterListError(err));
          return err.response;
        }
      });
}

//Bank Master functions

export function getFunctionMasterListSuccess() {
  return {
    type: functionMasterListActions.FUNCTION_MASTER_LIST_SUCCESS,
    isPosting: true,
  };
}
export function getFunctionMasterListError(error) {
  return {
    type: functionMasterListActions.FUNCTION_MASTER_LIST_ERROR,
    payload: error,
  };
}

export function getProductType(props) {
  const { access_token, url, type } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_URL}/getAllPartnerProductMaster`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getProductnMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getProductMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getProductMasterListError(err));
          return err.response;
        }
      });
}

//Bank Master functions

export function getProductnMasterListSuccess() {
  return {
    type: productListActions.PRODUCT_LIST_SUCCESS,
    isPosting: true,
  };
}
export function getProductMasterListError(error) {
  return {
    type: productListActions.PRODUCT_LIST_ERROR,
    payload: error,
  };
}

export function getPartnerType(props) {
  const { access_token, url, type } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_URL}/getAllPartnerTypeMaster`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPartnernMasterListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPartnerMasterListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPartnerMasterListError(err));
          return err.response;
        }
      });
}

//Bank Master functions

export function getPartnernMasterListSuccess() {
  return {
    type: partnerMasterListActions.PARTNER_MASTER_SUCCESS,
    isPosting: true,
  };
}
export function getPartnerMasterListError(error) {
  return {
    type: partnerMasterListActions.PARTNER_MASTER_ERROR,
    payload: error,
  };
}
